import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";

// The warm light card the 2-step steps use (the login components are styled for it, in light and dark theme).
// `hideTitle`: the step shows its own big title (the recovery codes do), so the dialog title is for screen readers only.
export const StepDialog = ({ open, onOpenChange, testid, title, description, hideTitle, children }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid={testid} {...(description ? {} : { "aria-describedby": undefined })}
      className="max-h-[92vh] max-w-md overflow-y-auto rounded-[28px] border-[#f0e6c8] bg-[#fdf8ec] p-7 text-[#1f1f24] sm:p-8">
      <DialogTitle className={hideTitle ? "sr-only" : "font-heading text-2xl font-bold tracking-tight"}>{title}</DialogTitle>
      {description && <DialogDescription className="text-sm text-[#5a554b]">{description}</DialogDescription>}
      {open && children}
    </DialogContent>
  </Dialog>
);
